import React, { useRef, useEffect, useCallback, useState} from 'react';
import {MAP, DELETE, OFF} from 'constants/midi-map-modes.js';
import {updateParameter} from 'operations/actions.js';
import {isNumber} from 'utils/IsNumber.js';

export const useParameterEditor = ({root, isMouseDown, onMouseDown, midiMapRef}, props) => {
    const parameterRef = useRef(props.parameter);
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(props.value || (props.parameter && props.parameter.get(true)));


    const onEdit = useCallback((e, edit=true) => {
        e.stopPropagation();
        if (edit !== editing && edit) {
            setValue(props.value);
        }
        setEditing(edit);
    }, [setEditing, setValue, props.value, editing]);

    const onUpdateParameter = useCallback((e, isSlider=true) => {
        let value = e.target.value;
        let inputValue = value;
        if (isSlider) {
            onMouseDown();
            value = pow(value, root);
        } else {
            if (value === '.' || value === '-.') {
                value = 0;
            } else if (value === '-') {
                value = 0;
            } else if (value === '-.') {
                value = 0;
            } else if (value === '') {
                value = 0;
            } else if (!isNumber(value)) {
                return;
            } else {
                value = parseFloat(value);
            }
        };

        let parameter = parameterRef.current;
        if (midiMapRef.current === MAP) {
            props.setParameterMidiMapSelection(parameter.id);
        }

        const operationManager = props.sequencerEngine && props.sequencerEngine.operationManager;
        if (operationManager) {
            operationManager.dispatch(
                updateParameter(parameter, value, false, false));
        } else {
            parameter.set(value, false);
        }
        setValue(value);
    }, [setValue, root]);

    useEffect(() => {
        if (editing) {
            return;
        }
        if (!isMouseDown.current) {
            setValue(props.parameter.get(true));
        }
    }, [editing, props.parameter, setValue]);

    const onKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            setEditing(false);
        }
    }, [setEditing]);

    useEffect(() => {
        parameterRef.current = props.parameter;
    }, [props.parameter]);

    
    return {
        onEdit,
        value,
        setValue,
        onUpdateParameter,
        setEditing,
        onKeyPress,
        editing};
};

const pow = (a,b) =>
      a < 0 ? -1 * Math.pow(Math.abs(a), b) :
      Math.pow(a,b);
